import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import CurrencyAdd from './add';
import CurrencyDelete from './delete';
import axios from 'axios';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import { useUser } from '../../AdminUsers/UserContext';
const Currency = () => {
    const { checkPermission } = useUser();
    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = async(status, type, data) => {
        setUpdateData(data);
        setEventType(type);
        if(type==="Add"){
            const hasPermission = await checkPermission("Currency", "create");
            if (!hasPermission) return;
          }else{
            const hasPermission = await checkPermission("Currency", "update");
            if (!hasPermission) return;
        }
        setAddPopupStatus(status);
        setViewPopupStatus(false);
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);

    const handleViewPopup = (type, data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = async (id) => {
        setDeleteId(id);      
        const hasPermission = await checkPermission("Currency", "delete");
        if (!hasPermission) return;      
        setDeletePopupStatus(true);
    };
    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };
    const [currencyData, setCurrencyData] = useState([]);

    const fetchCurrencyData = async () => {
        try {
            const response = await axios.get(
                `${baseUrl}/api/get_currency`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: localStorage.getItem('access_token'),
                    },
                }
            );

            if (response.data.status) {
                setCurrencyData(response.data.data);
            } else {
                console.error('Error: Failed to fetch user data');
            }
        } catch (error) {
            console.error('Error fetching users data:', error);
        }
    };


    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Currency Name',
                field: 'name',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '12%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Currency Symbol',
                field: 'symbol',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Symbol',
                    style: { width: '12%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Currency Code',
                field: 'code',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Code',
                    style: { width: '4%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }

        ],
        rows: currencyData && currencyData.map((data, index) => ({
            sno: index + 1,
            name: data.currency_name || "N/A",
            symbol: data.currency_symbol || "N/A",
            code: data.country_code || "N/A",
            action: (
                <div>
                    <Tooltip text="Update" id="update" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                        className="btn btn-sm btn-default edit_button_package"
                        title="Edit"
                        data-for="update"
                        data-tip
                    >
                        <i className="fa fa-edit"></i>
                    </button>
                    <Tooltip text="Delete" id="delete" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }}
                        className="btn btn-sm btn-default delete_button_package"
                        title="Delete"
                        data-for="delete"
                        data-tip
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
            clickEvent: () => handleViewPopup("Update", data),
        }))
    }
      // Check Admin User Permission
    const [checkUserLoading, setCheckUserLoading] = useState(false); 
    const fetchPermission = async () => {
      setCheckUserLoading(true);
      try {
        const hasPermission = await checkPermission("Currency", "view");
        if (!hasPermission) return;
      } catch (error) {
        console.error("Error fetching super specialty data:", error);
      }finally{
        setCheckUserLoading(false);
      }
    };
    useEffect(() => {
      fetchPermission();
    }, []);
    useEffect(() => {
        fetchCurrencyData();
    }, []);

    return (
        <>{checkUserLoading? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            ) : (
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Currency Master</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Currency Master</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true, "Add", {})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[10, 25, 50, 100]}
                                        entries={25}
                                        paging
                                        pagesAmount={5}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CurrencyAdd
                    fetchCurrencyData={fetchCurrencyData}
                    addPopupStatus={addPopupStatus}
                    handleAddPopup={handleAddPopup}
                    eventType={eventType}
                    updateData={updateData}
                />
                <CurrencyDelete
                    fetchCurrencyData={fetchCurrencyData}
                    deletePopupStatus={deletePopupStatus}
                    handleCloseDelete={handleCloseDelete}
                    deleteId={deleteId}
                />
                {updateData && <div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Curreny</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button onClick={() => handleDelete(updateData.id)} class="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i class="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={() => handleAddPopup(true, "Update", updateData)} class="saveand_proced_button btn btn-outline-info btn-block" type="button"><i class="fa fa-edit"></i> Edit </button>
                                </div>
                                <span onClick={() => setViewPopupStatus(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Currency Name</b> </small>
                                                            <p>{updateData.currency_name}</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Currency Symbol</b> </small>
                                                            <p>{updateData.currency_symbol}</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Currency Code</b> </small>
                                                            <p>{updateData.country_code}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>)}
        </>

    );

}
export default Currency
